
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faqJYYvQ_45jJzybyuhYr8ZROeirPO46xQxajAzXHa1NbkGYMeta } from "/codebuild/output/src435821134/src/src/pages/faq.vue?macro=true";
import { default as menukjNv1hSN6aZ9BWIDSH9UVoWU2V0pjewgWtLmTP4QkyEMeta } from "/codebuild/output/src435821134/src/src/pages/menu.vue?macro=true";
import { default as indexiGMt5JrDsqhtGBPJHwTYo7QD_Ce_MduKUKy0ghL_451c4Meta } from "/codebuild/output/src435821134/src/src/pages/index.vue?macro=true";
import { default as contactj9X8ge5GjDAkpLgNA9XlzhJdi1EXhSH03kmZv0z_F8EMeta } from "/codebuild/output/src435821134/src/src/pages/contact.vue?macro=true";
import { default as tutorialkspz9Qh3NV44j2pE_45b1GXMiDncUDvBO7aGDzzN0MWIEMeta } from "/codebuild/output/src435821134/src/src/pages/tutorial.vue?macro=true";
import { default as agreementdfbhtDK_45rz89f8JbMNGaM04k71Y2XuHH9jH21WjNFp8Meta } from "/codebuild/output/src435821134/src/src/pages/agreement.vue?macro=true";
import { default as about_45passY8VsMspJylS0VcbZxvg4xA8o377ZlxdnmdeTxpPJKwIMeta } from "/codebuild/output/src435821134/src/src/pages/about-pass.vue?macro=true";
import { default as indexE26DCEih4vVg2w9nQbA6UwQIAzQD475hCTp3cEmJBqkMeta } from "/codebuild/output/src435821134/src/src/pages/card/index.vue?macro=true";
import { default as _91id_93tHN_4560sVGmG0wq15RpSL_bhK_IpHVHU2J2fW0aR_45ieAMeta } from "/codebuild/output/src435821134/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenanceAbOCkqzzOx5MvghQ9S9XZbY68mtC8_45nyPItlcwa8heMMeta } from "/codebuild/output/src435821134/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_93VlzofAtjkcyHec_brsMB0XalgIGypCa1ufu20PXuCYEMeta } from "/codebuild/output/src435821134/src/src/pages/notice/[id].vue?macro=true";
import { default as indexO5kCu1QpWmXkK19MtXFVPzpxOtUj2WHtAkHMwhc3q7QMeta } from "/codebuild/output/src435821134/src/src/pages/coupon/index.vue?macro=true";
import { default as indexcZI1_45niavx0BDa_45Y4CapykC2hsJE0QcF8N5F_YzTtwkMeta } from "/codebuild/output/src435821134/src/src/pages/mypage/index.vue?macro=true";
import { default as indexBc6ddhvNRjuUMfFOS7nSViCNQMdkf5hN7dd90qgsUBMMeta } from "/codebuild/output/src435821134/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_93MSvsUOzExs4YMuHBQ3xFytYn4DrUbE7H5Rwv3xe33YwMeta } from "/codebuild/output/src435821134/src/src/pages/parking/[id].vue?macro=true";
import { default as index2OwOD9C1eveWvY_45Hrgb7O1D_HpF5tLizdMISjkRpDaUMeta } from "/codebuild/output/src435821134/src/src/pages/history/index.vue?macro=true";
import { default as index7kKk0QVZelYhstE8j1VnMkzBv5BxHRU9jKE__RDONzMMeta } from "/codebuild/output/src435821134/src/src/pages/monthly/index.vue?macro=true";
import { default as index8vbcHVm2NcEMJ8QYyWL68uiLKySECe8yVClYJAnfv6sMeta } from "/codebuild/output/src435821134/src/src/pages/sign-in/index.vue?macro=true";
import { default as indexcWMHzJYP3wsPzHQOZHqfj_450JoHWZJ6IIkM7uXkFn4G8Meta } from "/codebuild/output/src435821134/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenaviCoBdKYVmtK1i1zrglfwesUX1qZdexlXVf_nUdWIJj_45sMeta } from "/codebuild/output/src435821134/src/src/pages/about-yumenavi.vue?macro=true";
import { default as editT600GMUraBmC2ZFZCxHuGJyeobEHF7jNOTIA0KJQS_kMeta } from "/codebuild/output/src435821134/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreementYydD1qlp4eZlYBwPJ9GrzY3ZaknLWEQkjRfz7bS04DQMeta } from "/codebuild/output/src435821134/src/src/pages/pass-agreement.vue?macro=true";
import { default as indexdwI_pRvz1YeM524Yyy70_ptnC9SNNbWRVnFAI8IrwYsMeta } from "/codebuild/output/src435821134/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453duXl1tr7OOm0STAwXLgMusmsl7U1laTRX9d7EJPHj5WMMeta } from "/codebuild/output/src435821134/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirmdi_d7W_45mo4vfIzqGIl207vwzqH_45MDntPUGz2My42R8EMeta } from "/codebuild/output/src435821134/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as indexbvFgBDPsrzSnsKnJ0iRY2CbwgFX7pCKzDSqwnX7K8iAMeta } from "/codebuild/output/src435821134/src/src/pages/card/create/index.vue?macro=true";
import { default as indexcieTJeRiLxZKqTq2p1XBE_45AMPG4Vw0uUGZoTOjYeDAYMeta } from "/codebuild/output/src435821134/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirmKtq8EZk_4RxPkOEWfJMwAYtcODlJJL6ONjHNmpBVUAEMeta } from "/codebuild/output/src435821134/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirm13GilL3sNeuiL0n9v84UtyOv9_45hQrqbNbdTssVdLL2gMeta } from "/codebuild/output/src435821134/src/src/pages/card/create/confirm.vue?macro=true";
import { default as complete3KGCit08_H3YJVurZKx89IFN4p_45ElKvc03rw0P2b0XwMeta } from "/codebuild/output/src435821134/src/src/pages/membership/complete.vue?macro=true";
import { default as register9Lll9fa6pSQY_IkD2YfH5Ts67AEjTtVMtXoXs5WVUHcMeta } from "/codebuild/output/src435821134/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_935HsWkaIipGlpRhuqpvTRS_45i_45dV7FOKrUpMrLkYhQuboMeta } from "/codebuild/output/src435821134/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirmVJxzUFJ8vk74jD9IhorlrO1A0XLfC5T8Ej2l7lVFCtIMeta } from "/codebuild/output/src435821134/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_93r1fzrRnsw_455lzh0lWaCMoZtWt93tnUa0N7gNVqv5G6EMeta } from "/codebuild/output/src435821134/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as index86PsNsm78xLra4IrFDEZJYTWPLFu_45mPEHgbkvnIW570Meta } from "/codebuild/output/src435821134/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45codeZUkTje9s0j_45dTgv5p22fT3ft00szEvUMB_0OF8nQ0cAMeta } from "/codebuild/output/src435821134/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45codeTaWgGnvbhCd0xEHBQ9ROszL9sRJLC7RrmbS2i1AVDj0Meta } from "/codebuild/output/src435821134/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as complete7q_45WT8Tggu1GQICQXXIArqBqErHV7UJUYhkRfxu7ryMMeta } from "/codebuild/output/src435821134/src/src/pages/contact-form/complete.vue?macro=true";
import { default as registerp9fgtPlRD21S1HpmNTvLk0tWjR400qjz64b9i9p4ahEMeta } from "/codebuild/output/src435821134/src/src/pages/contact-form/register.vue?macro=true";
import { default as completeb3OnbkKgAxMzxOjxdlw28z1uXSIF_45VcBgsL1sP8XacAMeta } from "/codebuild/output/src435821134/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as indexzUb_45Ahe_45qiXe0nHNjQDK9N2yovghmxL_45Ltuj7Qva3WQMeta } from "/codebuild/output/src435821134/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirmSe4Wjw7MY_45BzGG_QS6uJXMGg0q6DXFL_45BVXqXe4zJyMMeta } from "/codebuild/output/src435821134/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as complete77HrvqB5X95zt71E7QdqDtNp_45zC2ZaIboGmvHU35qiQMeta } from "/codebuild/output/src435821134/src/src/pages/reset-password/complete.vue?macro=true";
import { default as indexBSHIUHLk3mjZKoPGwcESuySLnBMMO6eEMmA7elfQN4kMeta } from "/codebuild/output/src435821134/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_93orgvwr8vRnIXHGk1996s25DP4cmuikFoAOMK1DbNpUIMeta } from "/codebuild/output/src435821134/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as completevjzkSpbtDcSmvN2OHaOBXevmQckv5viQaAkji8sz99UMeta } from "/codebuild/output/src435821134/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45aliasR4xGO1yE4xhgcY4OElY3hg3r3EUwxfbjbZvus3Z1WQwMeta } from "/codebuild/output/src435821134/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as sampleHsUpIFZwst6u9_45hqJwfdsKtGLgYXjUh7mslM9erI3qoMeta } from "/codebuild/output/src435821134/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45emailI7AKSDxBNeSfD4D248JrhQP8i8JOMyrNX0u6xckRmTIMeta } from "/codebuild/output/src435821134/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirmDcpsZThRtDHLe1F80_45GKAreaBXP18oaMS_45GGTOrbolMMeta } from "/codebuild/output/src435821134/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consent1QBXiYUWn8q66xknLYtdybi48PIWz71MVad5oIFJZFkMeta } from "/codebuild/output/src435821134/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirmqv_0r_451PaQOO6nOjqlYxwYixQ2jCH4PIfVUGK_aIZV8Meta } from "/codebuild/output/src435821134/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedateu0_45INT4ZdBH2ur_45mI6aH0i71OZctRfIQh4JRSyEi2QoMeta } from "/codebuild/output/src435821134/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as complete9BxnYSdh5ZhYN9PizUVzWpaG1WDTr9UUwhA0ujzI29wMeta } from "/codebuild/output/src435821134/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45codejcmeQ0L95exKBNk1FU_s8xia_45KYRfBh9x1ixr3AL25cMeta } from "/codebuild/output/src435821134/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45passwordH4csSIGQbftkAFMjm2pXIeP0TXu6rhcQ5Z_45najrwqT0Meta } from "/codebuild/output/src435821134/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45aliasqkZaZ96nbWC_q47zOMFQT1jtYrKfev08shRppxd2jewMeta } from "/codebuild/output/src435821134/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as registerl_45gD0oBFyNUh60Cq9AJQHVzczaJsAQ2XsRlc54hthEoMeta } from "/codebuild/output/src435821134/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45codepTx2lzjKXMFpQstXuAs_xBOFhLh3wi5DyS04evlXvCMMeta } from "/codebuild/output/src435821134/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as indexCiStS7SGexvx8eAnFfwiuftnnbZSh7ckSOXYmkDm5iEMeta } from "/codebuild/output/src435821134/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as indexIhJWhj_45okrPsCUSz26AaZc_45JUb1nEkzlJ_5wBXTXqhgMeta } from "/codebuild/output/src435821134/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as indexZklGQFKNTOvhAtv2DVRHlj69jQ4HTnvWIzJNgPruRAgMeta } from "/codebuild/output/src435821134/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as index1Tbv0TU2uGDIK6Stlkcs5DzRrloESu_45x1xuQZNVQuyMMeta } from "/codebuild/output/src435821134/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as updatebwS6ZQ2TJfALVZxR_TkJOQz7E1zI8NQZ3HNaemQey9sMeta } from "/codebuild/output/src435821134/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as completedAnOxIUk8_45ZMhPkoGKB2gS0FU3vQc9dkBytaRCn2GekMeta } from "/codebuild/output/src435821134/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirmqBZYv3zBnNDhHKq_T_w71HlxcUkioQiO9kstxl6pkhUMeta } from "/codebuild/output/src435821134/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as indexSKE4Ebn2Pom6Z_p6iRieGo12cKsPGVcb0Y8Dzew0Fx4Meta } from "/codebuild/output/src435821134/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as completePaUU3GDKtyOGtIIfq0zwRKDFzy5serRC5UsqQ_45_450SiUMeta } from "/codebuild/output/src435821134/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as updateJW6NSPn1dtaqRBsFrnVH2s_A43xEB3mYeFeoqXNL6YwMeta } from "/codebuild/output/src435821134/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as indexVFHyEuVHsNDmEca9SCzDOY3YCsOqW8b902hu5guYIbAMeta } from "/codebuild/output/src435821134/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as indexUk7d79y0UbE6euF0yLjNsP_zIB5SNmmw7Mntlpr1ejEMeta } from "/codebuild/output/src435821134/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as completeYafK6emHIuwO1c4_babrwYzqAnBxPIV_45Qbdt2izAHpAMeta } from "/codebuild/output/src435821134/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as index5qyOyxIWsGWiAFawPejPEhS5vE7qjGtHtj5QW_intrIMeta } from "/codebuild/output/src435821134/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45code5_bTXJx4K9T5NVh5eb4gdIvN7_dn_451p6gkmwLFRexNcMeta } from "/codebuild/output/src435821134/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as indexUop6tUyK8t2Q94YGFc200uBwguVRm3f3Ks8rCm7OVfgMeta } from "/codebuild/output/src435821134/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as indexVWpFyeyCF2XoF2l8R0atte_45tFeKSQjiHkbz5iPV8LCUMeta } from "/codebuild/output/src435821134/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as indexLf8hS9xOQJ0W5TbU5jfw_458qcDfDZ9xagK9Ct1A51gJEMeta } from "/codebuild/output/src435821134/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as updateKRQo11Z8fZeglFzx4QK7M1kaL76qkDoNi2PrmqCLqrYMeta } from "/codebuild/output/src435821134/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirmIqMHZkigJV9Qc5TMvyBQIPNCZEgJ8dyLIAOfci7EcaUMeta } from "/codebuild/output/src435821134/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src435821134/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menukjNv1hSN6aZ9BWIDSH9UVoWU2V0pjewgWtLmTP4QkyEMeta || {},
    component: () => import("/codebuild/output/src435821134/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexiGMt5JrDsqhtGBPJHwTYo7QD_Ce_MduKUKy0ghL_451c4Meta || {},
    component: () => import("/codebuild/output/src435821134/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src435821134/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src435821134/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src435821134/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src435821134/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src435821134/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src435821134/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src435821134/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src435821134/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(indexO5kCu1QpWmXkK19MtXFVPzpxOtUj2WHtAkHMwhc3q7QMeta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src435821134/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src435821134/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src435821134/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src435821134/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(index2OwOD9C1eveWvY_45Hrgb7O1D_HpF5tLizdMISjkRpDaUMeta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src435821134/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src435821134/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: index8vbcHVm2NcEMJ8QYyWL68uiLKySECe8yVClYJAnfv6sMeta || {},
    component: () => import("/codebuild/output/src435821134/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: indexcWMHzJYP3wsPzHQOZHqfj_450JoHWZJ6IIkM7uXkFn4G8Meta || {},
    component: () => import("/codebuild/output/src435821134/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src435821134/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src435821134/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src435821134/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src435821134/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src435821134/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src435821134/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: indexbvFgBDPsrzSnsKnJ0iRY2CbwgFX7pCKzDSqwnX7K8iAMeta || {},
    component: () => import("/codebuild/output/src435821134/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src435821134/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirmKtq8EZk_4RxPkOEWfJMwAYtcODlJJL6ONjHNmpBVUAEMeta || {},
    component: () => import("/codebuild/output/src435821134/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirm13GilL3sNeuiL0n9v84UtyOv9_45hQrqbNbdTssVdLL2gMeta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src435821134/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: complete3KGCit08_H3YJVurZKx89IFN4p_45ElKvc03rw0P2b0XwMeta || {},
    component: () => import("/codebuild/output/src435821134/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: register9Lll9fa6pSQY_IkD2YfH5Ts67AEjTtVMtXoXs5WVUHcMeta || {},
    component: () => import("/codebuild/output/src435821134/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src435821134/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirmVJxzUFJ8vk74jD9IhorlrO1A0XLfC5T8Ej2l7lVFCtIMeta || {},
    component: () => import("/codebuild/output/src435821134/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src435821134/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src435821134/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45codeZUkTje9s0j_45dTgv5p22fT3ft00szEvUMB_0OF8nQ0cAMeta || {},
    component: () => import("/codebuild/output/src435821134/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45codeTaWgGnvbhCd0xEHBQ9ROszL9sRJLC7RrmbS2i1AVDj0Meta || {},
    component: () => import("/codebuild/output/src435821134/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: complete7q_45WT8Tggu1GQICQXXIArqBqErHV7UJUYhkRfxu7ryMMeta || {},
    component: () => import("/codebuild/output/src435821134/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: registerp9fgtPlRD21S1HpmNTvLk0tWjR400qjz64b9i9p4ahEMeta || {},
    component: () => import("/codebuild/output/src435821134/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src435821134/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src435821134/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirmSe4Wjw7MY_45BzGG_QS6uJXMGg0q6DXFL_45BVXqXe4zJyMMeta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src435821134/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: complete77HrvqB5X95zt71E7QdqDtNp_45zC2ZaIboGmvHU35qiQMeta || {},
    component: () => import("/codebuild/output/src435821134/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(indexBSHIUHLk3mjZKoPGwcESuySLnBMMO6eEMmA7elfQN4kMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src435821134/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src435821134/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: completevjzkSpbtDcSmvN2OHaOBXevmQckv5viQaAkji8sz99UMeta || {},
    component: () => import("/codebuild/output/src435821134/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src435821134/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(sampleHsUpIFZwst6u9_45hqJwfdsKtGLgYXjUh7mslM9erI3qoMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src435821134/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45emailI7AKSDxBNeSfD4D248JrhQP8i8JOMyrNX0u6xckRmTIMeta || {},
    component: () => import("/codebuild/output/src435821134/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirmDcpsZThRtDHLe1F80_45GKAreaBXP18oaMS_45GGTOrbolMMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src435821134/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consent1QBXiYUWn8q66xknLYtdybi48PIWz71MVad5oIFJZFkMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src435821134/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirmqv_0r_451PaQOO6nOjqlYxwYixQ2jCH4PIfVUGK_aIZV8Meta || {},
    component: () => import("/codebuild/output/src435821134/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src435821134/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(complete9BxnYSdh5ZhYN9PizUVzWpaG1WDTr9UUwhA0ujzI29wMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src435821134/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45codejcmeQ0L95exKBNk1FU_s8xia_45KYRfBh9x1ixr3AL25cMeta || {},
    component: () => import("/codebuild/output/src435821134/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45passwordH4csSIGQbftkAFMjm2pXIeP0TXu6rhcQ5Z_45najrwqT0Meta || {},
    component: () => import("/codebuild/output/src435821134/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src435821134/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: registerl_45gD0oBFyNUh60Cq9AJQHVzczaJsAQ2XsRlc54hthEoMeta || {},
    component: () => import("/codebuild/output/src435821134/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45codepTx2lzjKXMFpQstXuAs_xBOFhLh3wi5DyS04evlXvCMMeta || {},
    component: () => import("/codebuild/output/src435821134/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src435821134/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src435821134/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src435821134/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src435821134/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src435821134/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src435821134/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src435821134/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src435821134/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src435821134/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src435821134/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src435821134/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src435821134/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src435821134/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src435821134/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src435821134/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src435821134/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src435821134/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src435821134/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src435821134/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src435821134/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]